import React from "react";
import { graphql, useFragment } from "react-relay";
import { TodoToolbarEdit } from "widgets";
import { TodoEditNewMainToolbar_todo$key } from "./__generated__/TodoEditNewMainToolbar_todo.graphql";

import { ToolbarFeature } from "widgets/src/Todo/TodoToolbar/TodoToolbarItem";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";

export const TodoEditNewMainToolbar = React.memo(TodoEditNewMainToolbarC);
function TodoEditNewMainToolbarC(props: {
  todo: TodoEditNewMainToolbar_todo$key;
  openFeature: (feature: ToolbarFeature) => void;
}) {
  const { currentEmployeeId } = usePersistedEmployeeId();
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainToolbar_todo on Todo {
        ...TodoToolbarEdit_todo
      }
    `,
    props.todo
  );
  return (
    <TodoToolbarEdit
      todo={todo}
      openFeature={props.openFeature}
      currentEmployeeId={currentEmployeeId ?? undefined}
    />
  );
}
